import { render, staticRenderFns } from "./XinguanOrderForm.vue?vue&type=template&id=24db61df&"
import script from "./XinguanOrderForm.vue?vue&type=script&lang=js&"
export * from "./XinguanOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports